<template>
  <div class="c-multiselect-radio-button">
    <div
      v-for="(option, index) of options"
      :key="`${option}-${index}`"
      class="c-radio-button__option"
    >
      <btn
        :type="active.includes(index) ? 'primary' : 'primary-open'"
        :button-size="['small', 'thin']"
        @click.prevent="buttonClick"
      >
        {{ option }}
      </btn>
    </div>
  </div>
</template>
<script>
import Btn from '../button/Btn'
export default {
  components: {
    Btn
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    activeIndexes: {
      type: Array,
      default: () => [],
    }
  },
  data(){
    return {
      active: [],
    }
  },
  created() {
    if (
      this.activeIndex < this.options.length &&
      this.activeIndex >= 0
    ) {
      this.active = this.activeIndex;
    } else {
      this.active = []
    }
  },
  methods: {
    buttonClick(event) {
      for (let [index, option] of this.options.entries()){
        if (
          !this.active.includes(index) &&
          option == event.target.innerHTML.trim()
        ) {
          this.active.push(index)
        } else if (
          this.active.includes(index) &&
          option == event.target.innerHTML.trim()
        ) {
          for (let i in this.active){
            if (this.active[i] == index) {
              this.active.splice(i, 1)
            }
          }
        }
      }
      let selectedValues = []
      for (let i of this.active) {
        selectedValues.push(this.options[i])
      }
      this.$emit('input', { selectedValues, activeIndexes: this.active })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-radio-button__option{
  margin: rem(10px);
  display: inline-block;
}
</style>
